export const generateProjectIssueTypesQueryVariables = (projectAri: string) => ({
	projectAri,
});
